/**
 * The web half of the SYCEBNL vertical. Its strings already live in the base
 * catalogue and its routes in the base router, so it contributes neither.
 */
import type { SectorModuleUi } from '../types';
import { associationNav } from './nav';

export const associationUi: SectorModuleUi = {
  code: 'ASSOCIATION',
  nav: associationNav,
  routes: [],
  messages: {},
};
